import { TFunction, initSagaI18n } from "@saga/core"

export const initI18n = (): Promise<TFunction> => initSagaI18n()
